import { useEffect, useState, useRef, useCallback } from "react";
import ArticleCard from "../../components/Artigos/ArticleCard";
import ArticleModal from "../../components/Artigos/ArticleModal";

import TitleAbout from "../../components/Title"
import { getArticles } from "../../components/Artigos/articlesService";
import Ouvidoria from "../../components/Ouvidoria";

const ArticlesPage = () => {
  const [articles, setArticles] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const loader = useRef(null);

  const loadArticles = useCallback(async () => {
    try {
      const latestArticles = await getArticles();
      setArticles(latestArticles);
    } catch (error) {
      console.log("Erro ao buscar artigos:", error);
    }
    setLoading(true);
    setLoading(false);
  }, []);

  useEffect(() => {
    loadArticles();
  }, [loadArticles]);

  useEffect(() => {
  const target = loader.current; // salvar em variável local
  const observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting && !loading) {
        // setPage(prev => prev + 1);
      }
    },
    { threshold: 1.0 }
  );

  if (target) observer.observe(target);

  return () => {
    if (target) observer.unobserve(target);
  };
}, [loading]);


  const handleSearch = e => {
    setArticles([]);
    // setPage(1);
    setSearch(e.target.value);
  };

  return (
    <>
      <TitleAbout name="Artigos" link1={"Home / "} link2={"Artigos"}/>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Artigos</h1>

        <input
          type="text"
          placeholder="Buscar por título..."
          className="mb-6 px-4 py-2 border rounded w-full"
          value={search}
          onChange={handleSearch}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map(article => (
            <ArticleCard key={article.id} article={article} onOpen={setSelectedArticle} />
          ))}
        </div>

        {loading && <p className="text-center mt-6">Carregando mais artigos...</p>}
        <div ref={loader} className="h-10" />

        {selectedArticle && (
          <ArticleModal article={selectedArticle} onClose={() => setSelectedArticle(null)} />
        )}
      </div>
      <Ouvidoria/>
    </>
  );
};

export default ArticlesPage;
